import { ITableConfig } from "@/components/table/table.model";
import { SORTING_DIR } from "@/common/models";
import { DynamicsTableType } from "./model";

const downloads_table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "",
      sortable: false,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "3rem",
      spanMax: "3rem",
    },
    {
      name: "Name",
      key: "view_name",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "15rem",
      spanMax: "1fr",
    },
    {
      name: "Employee email",
      key: "employee_email",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "20rem",
      spanMax: "1fr",
    },

    {
      name: "Export Date",
      key: "export_date",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "15rem",
      spanMax: "15rem",
    },
    {
      name: "# Entities in list",
      key: "download_count",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "14rem",
      spanMax: "14rem",
    },
    {
      name: "Entity type",
      key: "entity_type",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "14rem",
      spanMax: "14rem",
    },
  ],
};

export const get_table_config = (type: DynamicsTableType) => {
  switch (type) {
    case "downloads":
    case "top-employees":
    case "top-views":
    default:
      return downloads_table_config;
  }
};
